/**
 * @type {Blank}
 * ブランク
 */
module.exports = class Blank {

  /**
   * Constructor
   */
  constructor() {
  }

  /**
   * To display table
   */
  toDisplay() {
    return [
      {
        alt      : '',
        img      : '',
        sourceUrl: ''
      }
    ];
  }
}
